import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container mx-auto flex lg:justify-around justify-center items-center lg:flex-row flex-col lg:mt-0 mt-12 mb-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_banner_component = _resolveComponent("banner-component")!
  const _component_fa = _resolveComponent("fa")!
  const _component_info_card_component = _resolveComponent("info-card-component")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_banner_component),
    _cache[3] || (_cache[3] = _createStaticVNode("<article class=\"container mx-auto flex justify-center mt-12\"><section class=\"rounded lg:w-2/4 w-4/5 lg:h-72 flex items-center text-center flex-col subpixel-antialiased\"><h1 class=\"text-gray-700 font-bold text-2xl my-4\">Beste klanten</h1><h3 class=\"text-gray text-md\"> Flavours is de engelse vertaling van het woord “smaken”. En smaken verschillen. <p> Sommige mensen houden van een zoutje, anderen hebben het dan weer graag pikant en sommigen hebben een voorkeur voor zoet. No problemo! Wij hebben vast wel een smaak in huis die bij u past. Grote honger, kleine honger of gewoon even zin in koffie of ander lekkers, spring zeker even binnen. </p></h3><h3 class=\"text-gray text-md mt-6\">Tot binnenkort!</h3></section></article>", 1)),
    _createElementVNode("article", _hoisted_1, [
      _createVNode(_component_info_card_component, { class: "mb-6 md:mb-0" }, {
        icon: _withCtx(() => [
          _createVNode(_component_fa, { icon: ['fas', 'calendar-alt'] })
        ]),
        content: _withCtx(() => _cache[0] || (_cache[0] = [
          _createElementVNode("h2", { class: "font-bold text-gray-700 my-2 text-md" }, "Openingsuren", -1),
          _createElementVNode("div", { class: "flex flex-col text-sm" }, [
            _createElementVNode("p", null, "Maandag - Vrijdag: 08:00 - 15:00"),
            _createElementVNode("p", null, "Zaterdag: 09:00 - 15:00")
          ], -1),
          _createElementVNode("div", { class: "mt-2 text-sm" }, [
            _createElementVNode("p", null, "Zondag & feestdagen gesloten !")
          ], -1)
        ])),
        _: 1
      }),
      _createVNode(_component_info_card_component, { class: "mb-6 md:mb-0" }, {
        icon: _withCtx(() => [
          _createVNode(_component_fa, { icon: ['fas', 'mobile-alt'] })
        ]),
        content: _withCtx(() => _cache[1] || (_cache[1] = [
          _createElementVNode("h2", { class: "font-bold text-gray-700 my-2 text-md" }, "Service", -1),
          _createElementVNode("div", { class: "flex flex-col" }, [
            _createElementVNode("p", { class: "md:text-sm text-xs" }, "Vermijd wachttijden, bestel op voorhand."),
            _createElementVNode("p", { class: "md:text-sm text-xs" }, " Bestellingen vóór 10u30 kunnen op het gewenste uur worden afgehaald. ")
          ], -1),
          _createElementVNode("div", { class: "mt-2" }, [
            _createElementVNode("p", { class: "md:text-sm text-xs" }, "Bestellen kan via telefoon (03 298 88 13)")
          ], -1)
        ])),
        _: 1
      }),
      _createVNode(_component_info_card_component, { class: "mb-6 md:mb-0" }, {
        icon: _withCtx(() => [
          _createVNode(_component_fa, { icon: ['fas', 'circle-exclamation'] })
        ]),
        content: _withCtx(() => _cache[2] || (_cache[2] = [
          _createElementVNode("h2", { class: "font-bold text-gray-700 my-2 text-md" }, "Klachten", -1),
          _createElementVNode("div", { class: "flex flex-col" }, [
            _createElementVNode("p", { class: "text-sm" }, "Heeft u een klacht of een opmerking?"),
            _createElementVNode("p", { class: "text-sm" }, "Aarzel dan niet ons te contacteren!")
          ], -1)
        ])),
        _: 1
      })
    ])
  ]))
}